import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Categories } from "@/components/site/Categories";
import { Showcase } from "@/components/site/Showcase";
import { About } from "@/components/site/About";
import { WhyUs } from "@/components/site/WhyUs";
import { Custom } from "@/components/site/Custom";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-sand" data-testid="jk-home-page">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Categories />
        <Showcase />
        <About />
        <WhyUs />
        <Custom />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
